import * as Html from "../../util/Html.ts";
import * as i18n from "../../i18n.ts";
import {listAllCurrency} from "../../lib/Currency.ts";

Html.registerWidget('widget/specific/select-currency',{initDom})

function initDom(select: HTMLElement): void {
  if (!(select instanceof HTMLSelectElement)) {
    //TODO maybe throw something instead of that log
    console.warn("init() appelé sur un élément non <select>", select);
    return;
  }
  const selectedValue = select.getAttribute("data-fw-select-value");

  const options = listAllCurrency(i18n.getShortLanguage())
    .map((currency: { code: string; name: string }) =>
      `<option value="${currency.code}">${currency.name}</option>`
    )
    .join("");

  // Injecte les <option> dans le <select>
  select.innerHTML = options;

  // Sélectionne la bonne valeur
  if (selectedValue) {
    select.value = selectedValue;
  }
}